
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/requires-confirmation",
      function () {
        return require("private-next-pages/mobiworkx/requires-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/requires-confirmation"])
      });
    }
  